export default "__VITE_ASSET__OczG0tif__"